export default "/_next/static/assets/images/lotto/star.cc6ebd434c95a9a5e3504d6fe725ac90.png";